<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 
         

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('paterno')">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            Residencia Fiscal del {{title}}
          </md-card-header>
          <md-card-content>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>
          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('residenciafiscaltributariadistintoperu')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            ¿Tiene residencia fiscal/tributaria en un país distinto al Perú? *
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.residenciafiscaltributariadistintoperu" value="Si" :disabled="isDisabled">Sí</md-checkbox>
                <md-checkbox v-model="form.residenciafiscaltributariadistintoperu" value="No" :disabled="isDisabled">No</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('residenciafiscaltributariadistintoperu')">
                <span class="md-error" v-if="!$v.form.residenciafiscaltributariadistintoperu.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>          

        <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
// import { alpha } from '../variables'
import {
  required,
//   minLength,
//   numeric,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  name: 'Item3',
  props:["title", "isDisabled"],
  data: () => ({
    form:{
    }
  }),

  mounted: function(){
    this.form = this.$store.state.item.item3
    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {
        residenciafiscaltributariadistintoperu: {required,},
      }        
    }
    return validate;
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item3
    },       
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        var index = "0"
        if(this.form.residenciafiscaltributariadistintoperu == "Si"){
          index = "4"
        }else{
          index = "5"
        }

        this.$emit('setSaveForm', {id:"3", form: this.form, index: index}); 

      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
     
  },
  computed: {
   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
